import React, { useCallback, useState } from 'react';
import { UnmountClosed } from 'react-collapse';
import Header from '~/App/views/ObjectPage/components/BiddingView/components/AdditionalServices/components/Header';
import { ObjectServiceRecord } from '~/config/generated/graphql';
import StructuredText from '../../../../../components/DatoCMS/StructuredText';
import { Button } from '@kvdbil/components';
import Link from '~/App/shared/components/Link';
import styled from 'styled-components';
import { useTranslation } from '~/Locale';

const CenteredLink = styled(Link)`
  text-align: center;
`;

const ServiceContentContainer = styled.div`
  padding: 0 1rem 1rem;
`;

type Props = {
  service: ObjectServiceRecord;
};

const HeavyEquipmentService = ({ service }: Props) => {
  const { t } = useTranslation();
  const [isExpanded, setIsExpanded] = useState(false);

  const Icon = useCallback(
    () => (
      <img
        alt={service?.icon?.alt ?? t('Service icon')}
        src={service?.icon?.url}
      />
    ),
    [service?.icon?.alt, service?.icon?.url, t]
  );

  const ariaControls = 'additional-service-heavy-equipment-content';

  return (
    <>
      <Header
        isExpanded={isExpanded}
        toggleExpanded={() => setIsExpanded(!isExpanded)}
        title={service?.title ?? ''}
        icon={Icon}
        responsiveImage={service?.image?.responsiveImage}
        description={service?.description ?? ''}
        ariaControls={ariaControls}
      />

      <UnmountClosed isOpened={isExpanded}>
        <ServiceContentContainer id={ariaControls}>
          <StructuredText data={service?.content} />

          {service?.link?.[0] && (
            <CenteredLink to={service.link[0]?.url}>
              <Button style={{ margin: '0 auto' }} color="info" variant="flat">
                {service.link[0]?.text}
              </Button>
            </CenteredLink>
          )}
        </ServiceContentContainer>
      </UnmountClosed>
    </>
  );
};

export default HeavyEquipmentService;
